import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

// The app's section label: a small-caps anchor that carries page hierarchy.
// Full ink, deliberately louder than body text — muted labels over dark
// content read as one wall of grey. Typography only: accent colour stays
// reserved for actions and node-type semantics.
export function SectionLabel({ className, children, ...props }: HTMLAttributes<HTMLParagraphElement>) {
  return (
    <p
      className={cn('text-xs font-semibold uppercase tracking-wide text-foreground', className)}
      {...props}
    >
      {children}
    </p>
  );
}
